import { render, staticRenderFns } from "./CrudBrowser.vue?vue&type=template&id=2404e08d"
import script from "./CrudBrowser.vue?vue&type=script&lang=js"
export * from "./CrudBrowser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports